<template> 

  <div class="container pt-4">

    <div v-if="!selectedSchema">

      Wybierz styl:
 
      <b-list-group class="mt-3">
        <b-list-group-item :class="{ 'text-primary': (item.type == 'label'), 'pl-3': (item.type !== 'label') }"  v-for="item in schema" class="pointer" :key="item.name" button @click="selectSchema(item)">
          
          <span class="material-symbols-outlined align-middle" v-if="item.icon">{{ item.icon }}</span> {{ item.name }}
          <small v-if="item.description"><br/>{{ item.description }}</small>
        </b-list-group-item>
      </b-list-group>
 
    </div>
 
    <div v-if="selectedSchema">
      
      <b-row align-v="center">

        <b-col lg="12">

          <h2>
            
            <button class="btn btn-white" size="sm" @click="selectedSchema = ''">
              <span class="material-symbols-outlined align-middle">
                keyboard_return
              </span>
            </button> 
            
            {{ this.selectedSchema.name }}
         
          </h2>
          <div v-if="this.selectedSchema.description"><br/>{{ this.selectedSchema.description }}</div>
          <hr/>
          

          <div class="mt-4">
              
      
            <div v-if="this.selectedSchema.fields.includes('WSTAW NAZWĘ PRODUKTU')">

              <label>Wpisz nazwę produktu:</label>
              
              <b-input-group>
          
                <b-form-input v-model="topic" ref="productName" placeholder="np. tabletki odchudzające"></b-form-input>
                
              </b-input-group>

            </div>

            <div v-if="this.selectedSchema.fields.includes('WSTAW KRÓTKI OPIS')" class="mt-3">

              <label>Krótki opis produktu/usługi:</label>

              <b-input-group>

                <b-form-input v-model="shortDesc" ref="shortDesc" placeholder="np. nasza usługa to zainstalowanie paneli. Wyróżnia nas to, że robimy to szybko i mamy niższe ceny niż konkurencja. Kolor roweru to czerwień. Rower posiada kosz."></b-form-input>
                
              </b-input-group>

            </div>

            <div v-if="this.selectedSchema.fields.includes('WSTAW GRUPĘ DOCELOWĄ')" class="mt-3">

              <label>Wstaw nazwę grupy docelowej:</label>

              <b-input-group>

                <b-form-input v-model="group" ref="group" placeholder="np. mieszkańcy domów jednorodzinnych, księgowe"></b-form-input>
                
              </b-input-group>

            </div>

            <div v-if="this.selectedSchema.fields.includes('WSTAW TON')" class="mt-3">

              <label>Wybierz ton:</label>

              <b-input-group>

                <b-form-select v-model="tone" ref="tone" :options="tones"></b-form-select>
               
              </b-input-group>

            </div>

            <br/>
 
            <b-form-checkbox v-model="addEmoji" value="true">Dodaj emoji</b-form-checkbox>
 
          </div>

        </b-col>

      </b-row>
  
      <hr/>

      <b-row align-v="center" class="mt-2" style="min-height: 40px;">

        <b-col lg="6">
        
        </b-col>

        <b-col lg="6">

        <b-button variant="outline-success mr-1" ref="generatePost" @click="generateFinish()" class="mt-3 float-right">
          <span class="material-symbols-outlined align-middle">
            bolt
          </span>
          Generuj
        </b-button> 

        </b-col>

      </b-row>



      <div class="mt-2" >
  
        <b-card header-tag="header" class="mt-4" v-if="isFinish">

          <template #header>

            <h6 class="mb-0 mt-2 float-left">
              <span v-if="!finishContent"><b-spinner variant='secondary' small></b-spinner> AI generuje ofertę dla Ciebie <small>(może to potrwać dłuższą chwilę. Nie odświeżaj strony!)</small></span>
              <span v-if="finishContent">Wygenerowana oferta</span>
            </h6>

            <b-button class="float-right p-0" variant="outline-white" @click="isFinish = false">

              <span class="material-symbols-outlined mt-1">close</span>

            </b-button>

          </template>

          <blockquote class="blockquote mb-0" v-if="result" style="font-size: 1em;">
            
            <div v-html="result" class="mb-3 mt-3 p-3" style="border: 1px dashed #f3f3f3; font-size: 1em; line-height: 1.7em;"></div>

            <div class="text-primary pointer small mt-1 float-right" @click="copyResults">

              <span class="material-symbols-sharp align-middle">content_copy</span>
              Kopiuj do schowka

            </div>

          </blockquote>

        </b-card>
  
  
        <textarea ref="selectedText" style="display: none;" v-model="selectedText" v-on:focus="$event.target.select()"></textarea>   
        <textarea ref="finishContent" style="display: none;" v-model="finishContent" v-on:focus="$event.target.select()"></textarea>

      </div>

    </div>

  </div>

</template>

<script>

  export default {
    name: 'AppCopyLegendAi',
    components: {
    },
    data() {
      return {
        isFinish: false,
        result: "",
        selectedText: '',
        topic: "",
        productName: "",
        occupation: "",
        comment: "",
        industry: "",
        name: "",
        tematyka: "",
        problem: "",
        client: "",
        w_czym_pomagasz: "",
        style: "",
        tone: "",
        pasteText: "",
        addEmoji: false,
        addCallToFollow: false,
        addHashtags: false,
        finishContent: '',
        tones: [
           'Beztroski' ,
           'Buntowniczy' ,
           'Charyzmatyczny' ,
           'Dociekliwy' ,
           'Dyplomatyczny' ,
           'Dystansujący się' ,
           'Elegancki' ,
           'Emocjonalny' ,
           'Entuzjastyczny' ,
           'Euforyczny' ,
           'Humorystyczny' ,
           'Inspirujący' ,
           'Ironiczny' ,
           'Konkretny' ,
           'Krytyczny' ,
           'Melancholijny' ,
           'Naukowy' ,
           'Neutralny' ,
           'Obojętny' ,
           'Oficjalny' ,
           'Optymistyczny' ,
           'Oschły' ,
           'Perswazyjny' ,
           'Pesymistyczny' ,
           'Profesjonalny' ,
           'Prosty i zrozumiały' ,
           'Przepraszający' ,
           'Przyjazny' ,
           'Rzeczowy' ,
           'Sarkastyczny' ,
           'Sentymentalny' ,
           'Serdeczny' ,
           'Sprzedażowy' ,
           'Subtelny' ,
           'Tajemniczy' ,
           'Troskliwy' ,
           'Uczuciowy' ,
           'Wspierający' ,
           'Zabawny' ,
           'Zawoalowany' ,
           'Zawzięty' 
        ],
        selectedSchema: null,
        schema: [
          {
            name: "Claude Hopkins",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW KRÓTKI OPIS", "WSTAW GRUPĘ DOCELOWĄ", "WSTAW TON"],
            command: "Wciel się w genialnego copywritera Claude Hopkinsa i napisz rozszerzoną ofertę sprzedażową [SALES COPY] dla [WSTAW NAZWĘ PRODUKTU] celem oferty jest sprzedać jak najwięcej produktów. Oto opis produktu żeby łatwiej było Ci napisać ofertę [WSTAW KRÓTKI OPIS]. Użyj tonu [WSTAW TON]. Grupą docelową są [WSTAW GRUPĘ DOCELOWĄ]. Wstaw następujące power words [nowoczesny, zaledwie, poczujesz, nie wystarcza, nowe metody, to najlepsza okazja, teraz]. Zacznij od nagłówka [HEADLINE] Nowość! Nowy sposób na [PROBLEM KLIENTA]. Następnie zastosuj obietnicę i napisz tekst w stylu „Poznaj nowy sposób na [PALĄCY PROBLEM KLIENTA] bez [TRUDNA CZYYNOŚĆ, KTÓREJ NIE CHCE WYKONYWAĆ KLIENT] i [DRUGA TRUDNA CZYNNOŚĆ, KTÓREJ NIE CHCE WYKONYWAĆ KLIENT]. Następnie napisz ofertę według sekwencji najpierw opisz problem klienta, potem opisz co się stanie jak klient zlekceważy ten problem a następnie opisz rozwiązanie problemu, którym jest twój produkt. Na końcu dodaj CTA czyli wezwanie do akcji."
          },
          {
            name: "David Ogilvy",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW KRÓTKI OPIS", "WSTAW GRUPĘ DOCELOWĄ", "WSTAW TON"],
            command: "Napisz mi ofertę sprzedażową używając stylu Davida Ogilvy. Oferta ma dotyczyć [WSTAW NAZWĘ PRODUKTU] dla grupy odbiorców: [WSTAW GRUPĘ DOCELOWĄ].  Oto opis produktu [WSTAW KRÓTKI OPIS]. Napisz ofertę w tonie: [WSTAW TON]. Zacznij od losowego nagłówka z listy 101 headline copywriterskich. Oto opis stylu Davida Ogilvy: Ogilvy skupiał się na zrozumieniu potrzeb, motywacji i zachowań konsumentów. W swoich reklamach często poruszał problemy i pragnienia odbiorców, prosty i klarowny przekaz, wyliczanie korzyści dla konsumenta."
          },
          {
            name: "Zapalniczka Zippo",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ].  Oto przykładowy tekst: Autor Nagrody Pulitzera, MacKinlay Kantor, używa tej zapalniczki Zippo od 1951 roku. Działa ona do dziś. Hak użyty w każdej z tych reklam. Bez względu na to, ile ma lat, jeśli Twój Zippo kiedykolwiek przestanie działać, naprawimy go bezpłatnie Słynna gwarancja Zippo. Zapalniczka Zippo MacKinlaya Kantora miała już trzy lata, kiedy w 1953 roku zaczął pisać swoją wspaniałą powieść o wojnie secesyjnej „Andersonville”. W 1955 roku książka została opublikowana i zdobyła nagrodę Pulitzera dla najlepszej powieści roku. Pan. Zippo Kantora wciąż działało. Za każdym razem Pan Kantor jest autorem takich klasyków jak „The Voice of Bugle Ann” i „Glory For Me”, przejmującej powieści wierszem, na podstawie której nakręcono jeden z najpopularniejszych filmów wszechczasów „The Best Years of Our Zyje.” . W 1956 roku Pan Kantor zaczął pisać swoją główną powieść „Spirit Lake”, która właśnie się ukazała. Jak widać na naszym zdjęciu, jego zapalniczka Zippo nadal działa. Dziesięcio-, piętnastoletnie i dwudziestopięcioletnie Zippo, które wciąż działają, nie należą do rzadkości."
          },
          {
            name: "Koszula Hathaway",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ]. Oto tekst, na którym masz się wzorować: Mężczyzna w koszulce Hathaway. Amerykanie wreszcie zaczynają sobie uświadamiać, że kupowanie dobrych garniturów, a potem psucie całego efektu noszeniem taniej, masowo produkowanej koszuli, jest śmieszne. Stąd rosnąca popularność koszul Hathaway, które są klasą samą w sobie. Po pierwsze, koszule Hathaway noszą się nieskończenie dłużej – to kwestia lat. Kontynuując, sprawiają, że wyglądasz młodziej i bardziej dystyngowanie, ze względu na sposób, w jaki Hathaway kroi kołnierzyki — nisko nachylone i „spersonalizowane”. Cała koszula jest cięta hojniej, a przez to wygodniej. Ogony są dłuższe i pozostają w spodniach. Guziki wykonane są z masy perłowej - bardzo duże i męskie. Nawet szwy mają w sobie antebellum elegancję. Koszule Hathaway szyją przede wszystkim z nietuzinkowych tkanin, sprowadzanych z czterech stron świata – Viyella i Aertex z Anglii, wełniana tafta z Auchterarder w Szkocji, bawełna Sea Island z brytyjskich Indii Zachodnich, ręcznie tkane jedwab z Indii, szerokie sukno z Manchesteru, lniany batyst z Paryża. Dostaniesz dużo cichej satysfakcji z noszenia koszul w tak nienagannym guście. Koszule Hathaway są wykonywane przez małą firmę oddanych rzemieślników w małym miasteczku Waterville w stanie Maine. Zajmują się tym, mężczyzna i chłopiec, od stu czternastu lat."
          },
          {
            name: "Frank Gold",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ]. Oto tekst, na którym masz się wzorować: „Jeśli chciałeś cieszyć się wszystkimi zaletami pięknego, prostego, promiennego uśmiechu, nadszedł czas, aby coś z tym zrobić. Już teraz, przez ograniczony czas, możesz zaoszczędzić 250 $. od standardowej opłaty za terapię Invisalign, a po zakończeniu leczenia możesz również skorzystać z bezpłatnego wybielania zębów, aby Twój piękny, nowy uśmiech błyszczał. Invisalign to dyskretna i praktycznie niewidoczna metoda leczenia ortodontycznego, stanowiąca wyraźną alternatywę dla metalowych aparatów ortodontycznych. Dzięki przezroczystym, polimerowym nakładkom Invisalign bez bisfenolu A możesz wyprostować zęby bez wiedzy innych osób, ponieważ nakładki Invisalign są tak blisko niewidoczne, jak to tylko możliwe. Są szanse, że po kilku dniach nawet nie zauważysz, że nakładki tam są, i nikt też tego nie zauważy, ponieważ nakładki Invisalign mogą inaczej, chyba że im powiesz. Wyjmowane nakładki wykonane z przezroczystego polimerowego materiału termoplastycznego, który nadaje im praktycznie niewidoczny wygląd. Bezpieczny do stosowania w jamie ustnej, jego wysoka masa cząsteczkowa dodaje wytrzymałości i trwałości, przy jednoczesnym zachowaniu elastyczności. Ponieważ co dwa tygodnie są one zastępowane następną nakładką z serii, zęby będą stopniowo przesuwać się, aż osiągną pożądaną pozycję. Nakładki Invisalign są łatwe w utrzymaniu. Jedną z największych zalet terapii Invisalign jest możliwość zdejmowania nakładek przez pacjentów, kiedy tylko zechcą, na maksymalnie dwie godziny dziennie."
          },
          {
            name: "Liberty Mutual",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ]. Oto tekst, na którym masz się wzorować: „Nie czytaj tego, jeśli kiedykolwiek byłeś aresztowany za brawurową jazdę! Jak ostrożni kierowcy mogą uzyskać ubezpieczenie samochodu po niższych kosztach. Marek stwierdził, że plan Liberty Mutual jest następujący: Ubezpieczamy ostrożnych kierowców, a nie lekkomyślnych kierowców. Ostrożni kierowcy mają mniej wypadków niż kierowcy lekkomyślni; dlatego nie musimy płacić za tak wiele wypadków. Dzięki temu zaoszczędzono wiele milionów dolarów. Ale nie przechowujemy tych pieniędzy. Przerzucamy to na właścicieli samochodów w postaci niższych kosztów ubezpieczenia. Czy to nie rozsądny plan? Oznacza to, że ostrożny kierowca nie musi płacić za wypadki nierozważnego kierowcy. Poza tym bardzo łatwo jest obsłużyć ubezpieczenie samochodu. przez Liberty Mutual. Bez kłopotu. Bez biurokracji. Oczywiście taki plan przynosi nam więcej wniosków o ubezpieczenie samochodu, niż jesteśmy w stanie przyjąć. Na przykład w zeszłym roku w jednym mieście odmówiliśmy obsługi ubezpieczenia samochodu ponad dwóch tysięcy kierowców. Akta tych mężczyzn pokazują, że wielu z nich zostało skazanych za lekkomyślną jazdę."
          },
          {
            name: "Gary Halbert",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ]. Zbadaj styl autora i zaimpementuj go do oferty. Oto tekst, na którym masz się wzorować: Co odkryła Tova Borgnine? Odpowiedź jest fascynująca. Jest to tajemnicza formuła, która pochodzi z korzenie kaktusa, który po raz pierwszy odkryli Indianie Aztekowie setki lat temu. A do niedawna ten niezwykły zabieg odmładzający był dostępny tylko w niektórych bardzo odległych częściach Meksyku. Jeśli mogłoby to zadziałać na ludzi żyjących w surowych, suchych środowiskach tego regionu, nie sądzisz, że mogłoby pomóc również tobie? Gwiazdy, które go używają, mówią, że działa jak magia. Cały proces zajmuje tylko pół godziny, a znawcy twierdzą, że nie ma nic podobnego dla nikogo, kto chce wyglądać o wiele lat młodziej niż ich rzeczywisty wiek kalendarzowy. Jest łatwy w użyciu. Wystarczy nałożyć formułę na twarz i czekać. „Krem jest różowy po nałożeniu i stopniowo zmienia kolor na biały” – mówi Towa. Gdy zmieni kolor na biały, należy go usunąć. Jedną ze wspaniałych rzeczy jest to, że nie ma zgadywania. Samo „wie”, co ma robić!„Ale najlepsze w tym wszystkim” — mówi Tova Borgnine — „jest to, że już po pierwszym zastosowaniu wyglądasz o wiele lat młodziej. W rzeczywistości” — mówi — „to jest to, co nazywam produktem „bez wymówek”. która jest w 100% poparta gwarancją firmy TOVA Corporation.”"
          },
          {
            name: "John Caples",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ]. Zbadaj styl autora i zaimpementuj go do oferty. Oto tekst, na którym masz się wzorować: Śmiali się, kiedy usiadłem przy pianinie, ale kiedy zacząłem grać! „Czy on naprawdę umie grać?” szepnęła dziewczyna. „Niebiosa nie!” wykrzyknął Artur. „Nigdy w życiu nie zagrał ani jednej nuty”. „Kiedy pojawił się kurs, okazało się, że jest tak łatwy jak w reklamie, że jest łatwy jak A.B.C.! A w miarę kontynuowania lekcji stawały się one coraz łatwiejsze. Zanim się zorientowałem, grałem wszystkie utwory, które najbardziej mi się podobały. Nic mnie nie powstrzymało. Mogłem grać ballady, numery klasyczne lub jazz, wszystko z równą łatwością. I nigdy nie miałem specjalnego talentu muzycznego. Graj na dowolnym instrumencie Ty również możesz teraz nauczyć się, jak zostać znakomitym muzykiem — w domu — w czasie o połowę krótszym niż zwykle. Nie możesz się pomylić z tą nową, prostą metodą, która pokazała już prawie pół milionowi ludzi, jak grać na ich ulubionych instrumentach. Zapomnij o staroświeckim pomyśle, że potrzebujesz specjalnego „talentu”. Po prostu przeczytaj listę instrumentów w panelu, zdecyduj, na którym chcesz grać, a U.S. School zajmie się resztą. I pamiętaj, bez względu na to, który instrument wybierzesz, koszt w każdym przypadku będzie taki sam – zaledwie kilka centów dziennie. Bez względu na to, czy jesteś dopiero początkującym, czy już dobrym wykonawcą, będziesz zainteresowany poznaniem tej nowej i wspaniałej metody."
          },
          {
            name: "Russell Brunson",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ]. Zbadaj styl autora i zaimpementuj go do oferty. Oto tekst, na którym masz się wzorować: Walczysz o stały przepływ klientów? Poznaj ClickFunnels. Przyciągaj udzi do Twojej witryny i zmienianie ich w zadowolonych płacących klientów to to, co robimy najlepiej. Brak umiejętności obsługi komputera Działa dla każdego rodzaju działalności Sprzedawaj, sprzedawaj i dostarczaj jak profesjonalista. Dlaczego więc lejek ? Spójrzmy prawdzie w oczy — strona internetowa bez płacących klientów jest jak budowanie sklepu na środku pustyni bez jednej drogi prowadzącej do niego. I tu pojawia się „lejek”. Lejek jest jak „cyfrowa droga”, która przenosi Twoich wymarzonych klientów na Twoją stronę internetową i do Twojego sklepu internetowego z ich kartami kredytowymi w ręku! ClickFunnels „ Lejki ” Klienci do Ciebie! Jesteśmy oryginalnym twórcą lejków i pierwszą w historii platformą zaprojektowaną, aby przyciągać ludzi z serwisów takich jak Facebook, Google, YouTube i Instagram czy TikTok… i sprowadzać ich do Twojego sklepu! Jeśli kiedykolwiek byłeś na jednej z tych witryn i kliknąłeś reklamę… są szanse — jeśli oni wiedzą, co robią — że  strona, na którą tafiłeś zaraz potem, była prawdopodobnie jednym z naszych lejków! I zgadnij co? Jesteś teraz w lejku! (Tak, naprawdę działają!) ClickFunnels zapewnia wszystko, czego potrzebujesz do wprowadzania na rynek, sprzedawania i dostarczania produktów online"
          },
          {
            name: "Gary Vaynerchuk",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ]. Zbadaj styl autora i zaimpementuj go do oferty. Oto tekst, na którym masz się wzorować: Jeśli chcesz dowiedzieć się, jak sprzedawać, jak wygrywać w biznesie i jak zdobywać nowych klientów, ten artykuł jest dla Ciebie. JAK SPRZEDAWAĆ W tym roku Sprzedaż, sprzedaż, sprzedaż. Jest to coś, o czym nie mówię wystarczająco dużo, ale jest to absolutnie podstawa mojej kariery. Rzucam sobie wyzwanie, aby wejść głębiej w 2019 roku, ponieważ jest to w 1000% podstawa biznesu. A jeśli tego nie zrozumiesz, przegrasz. Kiedy myślę o tym, żeby coś się wydarzyło na świecie, np. sprzedanie czegoś, otrzymanie darowizny, zdobycie głosu w wyborach, jakakolwiek „transakcja”, zawsze dzielę swoją strategię na sprzedaż i marketing . Oczywiście każdy, kto to czyta, wie, że spędzam ogromną ilość czasu na rozmowach o marce, znaczeniu marketingu, świadomości i przyciąganiu uwagi, co czasem odwraca uwagę od moich podstaw sprzedaży. Marketing i branding to tylko jedna część równania. Ostatecznie musisz ułatwiać transakcje, jeśli chcesz pozostać w grze. Liczby nie kłamią, a sprzedaż to absolutna podstawa Twojego biznesu. Po prostu nie ma innego sposobu. Jest więc kilka wypróbowanych i prawdziwych strategii, taktyk, wniosków i interesujących podobieństw na temat „jak sprzedawać”, którymi chcę się z Tobą podzielić. Przez całe życie byłem sprzedawcą, od obsługi stoisk z lemoniadą po sprzedaż kart baseballowych, wina i wielomilionowych teleskopów w VaynerMedia. Mogę śmiało powiedzieć, że w ciągu ostatnich 35 lat sprzedałem ogromne ilości 😉masom i niektórym z najważniejszych prezesów CMO i Brand Managerów firm z listy Fortune 100, którzy chcą zoptymalizować zwrot z inwestycji i poprawić zwrot z inwestycji. Luka w marketingu polega na tym, że czasami może być bardzo wysoko w chmurach i nikt nie rozumie bezpośredniego KPI. Jaka jest transakcja? Gdzie jest wyprzedaż? A kiedy pływy się zmienią… Idź dalej. Musisz nauczyć się być nieromantyczny, niezależnie od tego, czy jest to Facebook dzisiaj, czy Snap jutro. Niezależnie od tego, czy na początku był to Vine, Tumblr czy Vidler, 😉a teraz jest to Instagram, HQ, Anchor lub Musical.ly. To jest moja rada, to jest to, co musisz zrobić!"
          },
          {
            name: "Mirosław Skwarek",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ]. Zbadaj styl autora i zaimpementuj go do oferty. Oto tekst, na którym masz się wzorować: Sztuczna Inteligencja Napisze Za Ciebie Tysiące Postów Na Wszystkie Kanały W Social Mediach, a Wirtualna Asystentka AI Pomoże Ci Ogarnąć Pożary W Firmie. Otrzymasz też aplikację, która pisze posty w stylu 200 Celebrytów Świata. Do tego pakiet kursów nt. zarabiania za pomocą Sztucznej Inteligencji i 7 dniowy Coaching z AI. Od 13 lat pomagam przedsiębiorcom zarabiać więcej dzięki wykorzystaniu potencjału Social Mediów. Zauważyłem jednak, że większość przedsiębiorców nie ma efektów w pozyskiwaniu klientów, gdyż: - Nie mają czasu na tworzenie treści i wpisów na Facebooka czy Instagrama. -  Nie znają się na pisaniu postów. Boją się, że popełnią błędy a ich posty tylko ośmieszą firmę.- Nie ma ich na LinkedIn czy Twitterze bo…nie mają na to czasu.- Nie wiedzą, jak pisać posty, które sprzedają.- Wypala ich codzienne wymyślanie postów i tematów na treści. Agencja social media prowadzi ich kanały za duże pieniądze, a efektów niestety BRAK. W związku z tym od lat szukałem sposobu na to, żeby pomóc moim klientom rozwiązać te PALĄCE problemy. Od lat wraz z moim zespołem programistów pracujemy nad rozwiązaniami opartymi na sztucznej inteligencji. Jak aplikacje oparte na sztucznej inteligencji napiszą TYSIĄCE postów idealnych dla Twojej branży? No i wreszcie mogę ogłosić SUKCES. Właśnie stworzyliśmy oprogramowanie, które napisze za Ciebie (w 100%) genialne, przyciągające uwagę posty do wszystkich kanałów Social Media. To nie wszystko, w ramach pakietu otrzymujesz 7 aplikacji, gdzie każda z nich realizuje inne cele dla Twojej firmy. Dlaczego warto zainwestować w Pakiet 7 Aplikacji AI do Mirka Skwarka? Aplikacje napiszą Ci posty do wszystkich Social Mediów. Od Instagrama do LikedIn Nasze aplikacje nie tylko budują zasięgi, ale również nastawione i wyuczone są schematów sprzedażowych Aplikacje to oszczędność czasu. Wiele osób jest w szoku, że to co im zajmowało godzinę pisania nasza aplikacja zrobi w minutę. Czy 990 zł to drogo? Pomyśl, że miesięczne zatrudnienie pracownika to koszt 6000 zł. Czy Twój pracownik napisze posty sprzedażowe? Sztuczna inteligencja nie potrzebuje snu ani jedzenia. Nie buntuje się. Dodatkowo skąd weźmiesz pracownika, który przeczytał 500 000 książek? Ta propozycja wygasa już w poniedziałek o 23:59. Dołącz teraz"
          },
          {
            name: "Robert Collier",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ]. Zbadaj styl autora i zaimpementuj go do oferty. Oto tekst, na którym masz się wzorować:Drogi Czytelniku: Pewnego pięknego późnego wiosennego popołudnia, dwadzieścia pięć lat temu, dwóch młodych mężczyzn ukończyło ten sam college. Byli bardzo do siebie podobni, ci dwaj młodzieńcy. Obaj byli lepszymi niż przeciętni studentami, obaj byli przystojni i obaj – jak na młodych absolwentów college’u – pełni ambitnych marzeń na przyszłość.Niedawno ci mężczyźni wrócili do swojej uczelni na 25. zjazd.Nadal byli do siebie bardzo podobni. Oboje byli szczęśliwym małżeństwem. Obaj mieli po trzy dzieci. Okazało się, że obaj po ukończeniu studiów poszli do pracy w tej samej firmie produkcyjnej na Środkowym Zachodzie i nadal tam byli. Ale była różnica. Jeden z mężczyzn był kierownikiem małego działutej firmy. Drugi był jej prezesem.Co zrobiło różnicę Czy zastanawiałeś się kiedyś, tak jak ja, co powoduje taką różnicę w życiu ludzi? Nie zawsze jest to wrodzona inteligencja, talent czy poświęcenie. To nie jest tak, że jedna osoba chce sukcesu, a druga nie.Różnica polega na tym, co każdy wie i jak to wykorzystuje ta wiedza.I dlatego piszę do ciebie i do ludzi takich jak ty o The Wall Street Journal. Bo to jest cały cel The Journal: dać swoim czytelnikom wiedzę, którą mogą wykorzystać w biznesie.Publikacja inna niż wszystkie. Widzisz, The Wall Street Journal to wyjątkowa publikacja. To jedyny krajowy dziennik biznesowy. Każdego dnia roboczego jest on przygotowywany przez największy na świecie zespół ekspertów w dziedzinie wiadomości biznesowych.Każdego dnia roboczego strony The Journal zawierają szeroki zakres informacji interesujących i ważnych dla ludzi myślących biznesowo, bez względu na to, skąd pochodzą. Nie tylko akcje i finanse, ale wszystko i wszystko w całym, szybko zmieniającym się świecie biznesu... The Wall Street Journal dostarcza wszystkich potrzebnych wiadomości biznesowych — wtedy, gdy ich potrzebujesz.Wiedza to potęga Właśnie czytam pierwszą stronę Dziennika. Łączy w sobie wszystkie ważne wiadomości dnia z dogłębnymi raportami funkcji. Obejmuje każdą fazę wiadomości biznesowych, od artykułów na temat inflacji, cen hurtowych, cen samochodów, zachęt podatkowych dla przemysłu po ważne wydarzenia w Waszyngtonie i innych miejscach."
          },
          {
            name: "Eugene Schwartz",
            icon: "notes",
            fields: ["WSTAW NAZWĘ PRODUKTU", "WSTAW GRUPĘ DOCELOWĄ"],
            command: "Zaraz wkleję Ci przykładową ofertę a Ty na jej podstawie napisz ofertę [WSTAW NAZWĘ PRODUKTU] dla [WSTAW GRUPĘ DOCELOWĄ]. Zbadaj styl autora i zaimpementuj go do oferty. Oto tekst, na którym masz się wzorować: PRZECZYTAJ 300 CZASOPISMÓW BIZNESOWYCH W CIĄGU 30 MINUT ! I zdobądź odwagę każdego z ich najcenniejszych pomysłów w formie superkondensacji, której po prostu nie możesz zapomnieć! specjalne darmowe zaproszenie. Drogi Czytelniku: Przedstawiamy raporty zarządu dla generalistów, dyrektorów wykonawczych, którzy chcą znać wszystkie ważne nowości znane specjalistom z każdego ważnego obszaru… ale chcą je poznać w ciągu kilku minut, a nie godzin… i chcą wiedzieć w ciągu kilku sekund, co dokładnie każdy znaczy dla niego! Teraz Redakcja zaprasza do bezpłatnej lektury najnowszego numeru. Boardroom zabierze Cię tam, gdzie przeznaczenie kształtowanie wielkie decyzje są podejmowane! Gdzie najlepsi specjaliści decydują o losach całe branże. Lubię to... Tylko jeden niedawny przykład. Czy znasz prostą zmianę w procedurze księgowości, która praktycznie zniszczyła jedną z szybko rozwijających się gałęzi przemysłu? Po raz pierwszy wspomniano o tym w specjalistycznym czasopiśmie dla CPA… i tylko garstka dyrektorów w samej branży zdała sobie sprawę z jego niszczycielskiego wpływu dopiero kilka miesięcy później. Boardroom Reports skanuje tę publikację księgową i ponad dwa tuziny innych w tej samej specjalistycznej dziedzinie. Dlatego błysnęłaby ci sama decyzja… wraz z jej konsekwencjami dla zysków i strat oraz prawdopodobną katastrofalną reakcją Wall Street na nią zaledwie kilka dni po tym, jak sami specjaliści się o tym dowiedzieli! POMYŚL O PODŁĄCZENIU DO "
          }               
        ]
      }
    },
    methods: {

      selectSchema: function(item) {

        this.selectedSchema = item
      },

      generateFinish: function() {

        this.$refs.generatePost.disabled = true

        this.isFinish = true

        this.finishContent = ""
        this.result = ""

        var query = "";
  
        query = this.selectedSchema.command;

    
        if(this.$refs.productName)
          query = query.replaceAll('[WSTAW NAZWĘ PRODUKTU]', this.$refs.productName.value)

        if(this.$refs.shortDesc)
          query = query.replaceAll('[WSTAW KRÓTKI OPIS]', this.$refs.shortDesc.value)

        if(this.$refs.group)
          query = query.replaceAll('[WSTAW GRUPĘ DOCELOWĄ]', this.$refs.group.value)
 
        if(this.$refs.tone)
          query = query.replaceAll('[WSTAW TON]', this.tone)
 
          
        if(this.addEmoji) {

          query = query + "Dodaj emoji."

        }
 
   

        var doneText = "";

        this.axios.post(window.API_URL + "apps/aiPostCreator/getAiText/", { 'text': query }, { withCredentials: true, timeout: 3000000 }).then((response) => {
  
          let data = response.data

          if(data.redirectTo) {

            top.location.href = data.redirectTo;

          }

          doneText = data.result;

          this.finishContent = doneText;

          this.result = doneText.replace(/(?:\r\n|\r|\n)/g, '<br/>');

          this.$refs.generatePost.disabled = false
          this.generatedPostTitle = "Wygenerowana oferta"

        }).catch(function() {

          this.$refs.generatePost.disabled = false

         })
 
        
 
      },

      loadFromExample: function(keyword) {

        this.topic = keyword

      },

      copyResults: function() {
 
        this.$refs.finishContent.style.display = "block";
        
        this.$refs.finishContent.focus();

        document.execCommand('copy');
         
        this.$refs.finishContent.style.display = "none"

        window.scrollTo(0, 0)

        this.$bvToast.toast('Oferta została skopiowana do schowka', {
          title: 'Skopiowano',
          autoHideDelay: 5000,
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
          noCloseButton: true
        })

      } 

    },
    computed: {
  
    },
    created() {

      this.$watch('finishContent', (value) => {

        var lines = value.split(/\r|\r\n|\n/);

        this.finishLinesCount = lines.length;

      })
 
    }

  }
</script>

<style>

  .pointer { cursor: pointer; }
  .bold { font-weight: 600 !important; }
</style>